"use client";
import React, { useState } from "react";
import Image from "next/image";

interface ProjectImageSliderProps {
  images: any[];
  projectName: string;
}

const ProjectImageSlider: React.FC<ProjectImageSliderProps> = ({ images, projectName }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  if (!images || images.length === 0) {
    return null;
  }

  return (
    <div className="w-full">
      {/* Großes Hauptbild */}
      <div className="relative w-full h-[500px] md:h-[600px] mb-4 rounded-lg overflow-hidden">
        <Image
          src={images[selectedIndex]}
          alt={`${projectName} - Bild ${selectedIndex + 1}`}
          fill
          className="object-cover"
          priority={selectedIndex === 0}
        />
      </div>

      {/* Miniaturbilder */}
      {images.length > 1 && (
        <div className="grid grid-cols-4 gap-2 md:gap-4">
          {images.map((image, index) => (
            <button
              key={index}
              onClick={() => setSelectedIndex(index)}
              className={`relative h-20 md:h-24 rounded-lg overflow-hidden transition-all duration-200 ${
                selectedIndex === index
                  ? "ring-4 ring-company-color-primary opacity-100"
                  : "opacity-70 hover:opacity-100"
              }`}
            >
              <Image
                src={image}
                alt={`${projectName} - Miniatur ${index + 1}`}
                fill
                className="object-cover"
              />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProjectImageSlider;

